module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuODQ2NDYgNy41Mzc3MUwyLjcxNzcgNC4zOTgzTDIgNS4xMjk0NEw1Ljg0NjQ2IDlMMTIgMi43MzExNUwxMS4yODIzIDJMNS44NDY0NiA3LjUzNzcxWiIgZmlsbD0iIzFBQjkwMCIgc3Ryb2tlPSIjMUFCOTAwIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/appicons/CheckNotRound.svg
// module id = 1070
// module chunks = 0